// Attribution first-touch : capture le canal d'acquisition au 1er chargement et
// le conserve jusqu'a l'achat (suivi commercial LeadForge).
const KEY = 'lf_attribution';

export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const gclid = p.get('gclid') || '';

    // UTM en first-touch : si lf_attribution existe deja, on NE reecrit PAS les UTM.
    // Le gclid est last-touch -> on le met a jour a chaque passage avec un gclid present.
    const existing = localStorage.getItem(KEY);
    if (existing) {
      if (gclid) {
        try {
          const prev = JSON.parse(existing);
          prev.gclid = gclid;
          localStorage.setItem(KEY, JSON.stringify(prev));
        } catch (e) { /* objet corrompu : ne pas ecraser */ }
      }
      return;
    }

    const data = {
      utm_source: p.get('utm_source') || '',
      utm_medium: p.get('utm_medium') || '',
      utm_campaign: p.get('utm_campaign') || '',
      utm_term: p.get('utm_term') || '',
      utm_content: p.get('utm_content') || '',
      gclid: gclid,
      referrer: (document.referrer || '').slice(0, 500),
      landing_page: (window.location.pathname + window.location.search).slice(0, 500),
    };
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) { /* no-op */ }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch (e) { return {}; }
}

export function getGclid() {
  try {
    return (JSON.parse(localStorage.getItem(KEY) || '{}').gclid) || '';
  } catch (e) { return ''; }
}
